export var OrderLineCollectionStatus;
(function(OrderLineCollectionStatus) {
    OrderLineCollectionStatus[/**
     * Order line has not yet been collected.
     */ "NotCollected"] = "NotCollected";
    OrderLineCollectionStatus[/**
     * Order line has been collected.
     *
     * @remarks
     * The Collected status on a ticket represents a ticket that has been printed, or has
     * been scanned by a cinema operator to let the patron enter their screening. Similarly
     * the Collected status on an item represents an item where an item collection voucher
     * has been printed, or has been sent to the kitchen for preparation.
     *
     * Collection often needs to be indicated manually by clients, and only happens automatically
     * in specific scenarios and configurations.
     */ "Collected"] = "Collected";
})(OrderLineCollectionStatus || (OrderLineCollectionStatus = {}));

//# sourceMappingURL=order-line-collection-status.js.map